import React, { useCallback } from "react";
import classNames from "classnames";
import { SwitchMapIconMap, SwitchMapIconList } from "@kursk/components/ui/icons";
import styles from "./SwitchMapButton.module.scss";

interface IProps {
  currentView: 'map' | 'list';
  onSwitchToMapClick: () => void;
  onSwitchToListClick: () => void;
  className?: string;
}

export const SwitchMapButton = ({ currentView, onSwitchToMapClick, onSwitchToListClick, className }: IProps) => {

  const onClickHandle = useCallback(() => {
    if (currentView === 'map') {
      onSwitchToListClick();
    } else {
      onSwitchToMapClick();
    }
  }, [currentView]);

  return (
    <div onClick={onClickHandle} className={classNames([styles.wrapper, className])}>
      {currentView === 'map' ? (
        <>
          <SwitchMapIconList />
          <span className={styles.text}>Списком</span>
        </>
      ) : (
        <>
          <SwitchMapIconMap />
          <span className={styles.text}>На карте</span>
        </>
      )}
    </div>
  )
}
